import { Hero } from 'shared/layout/Hero'
import { Heading, Typography } from 'ui/typography'
import { useContentfulResourcesMapped } from '../../stores/Contentful/hooks'
import { ResourceUtils } from 'services/ContentfulService/models/resource/utils'
import { Container } from 'shared/layout/Container'
import { Divider, FlexBox, Stack } from 'ui/primitives'
import { AsideItem } from 'experiences/shared/Aside/AsideItem'
import { aside, textContainer } from './Support.css'
import { InlineSvg } from 'components/patterns/icons/svg-tools/InlineSvg'
import { QuestionsSection } from './QuestionsSection'
import { Link } from 'ui/navigation/Link'
import { ROUTES } from 'parameters/index'

export const SupportPage = () => {
	const pageResources = useContentfulResourcesMapped()

	const InlineSvgAsideIcon = ({ icon }: { icon: string }) => (
		<InlineSvg asset={ResourceUtils(pageResources['contact.aside.' + icon]).getMediaContent()} width={24} height={24} />
	)

	return (
		<>
			<Hero>
				<Heading.H1>{ResourceUtils(pageResources['faq.title']).getPlainTextContent()}</Heading.H1>
			</Hero>

			<Container>
				<FlexBox
					paddingY={{ xs: 'lg', md: 'xxl' }}
					gap={{ xs: 'lg', md: 'xxl' }}
					justifyContent="space-between"
					flexDirection={{ xs: 'column', md: 'row' }}
				>
					<Stack gap="xxl" className={textContainer}>
						<QuestionsSection contentfulKey="faq.section_one" />
						<QuestionsSection contentfulKey="faq.section_two" />
						<QuestionsSection contentfulKey="faq.section_three" />
						<QuestionsSection contentfulKey="faq.section_four" />
						<QuestionsSection contentfulKey="faq.section_five" />
						<QuestionsSection contentfulKey="faq.section_six" />
						<QuestionsSection contentfulKey="faq.section_seven" />
						<QuestionsSection contentfulKey="faq.section_eight" />
						<QuestionsSection contentfulKey="faq.section_nine" />

						<Stack gap="sm">
							<Heading.H2>{ResourceUtils(pageResources['faq.bottom_section']).getPlainTextContent()}</Heading.H2>
							<Divider borderColor="neutral.light" size="md" />
							<Typography>
								Click <Link href={ROUTES.CONTACT}>here</Link> to contact us!
							</Typography>
						</Stack>
					</Stack>

					<Stack gap="lg" alignSelf="flex-start" className={aside}>
						<Stack gap="sm">
							<Heading.H3>{ResourceUtils(pageResources['faq.aside.title']).getPlainTextContent()}</Heading.H3>
							<Typography>{ResourceUtils(pageResources['faq.aside.description']).getPlainTextContent()}</Typography>
						</Stack>
						<AsideItem
							icon={<InlineSvgAsideIcon icon="email" />}
							title={ResourceUtils(pageResources['contact.aside.email']).getPlainTextContent()}
							link={{
								text: 'help@hifiona.com',
								href: 'mailto:help@hifiona.com'
							}}
						/>
						<AsideItem
							icon={<InlineSvgAsideIcon icon="phone" />}
							title={ResourceUtils(pageResources['contact.aside.phone']).getPlainTextContent()}
							link={{
								text: '(800)-614-7505',
								href: 'tel:(800)-614-7505'
							}}
						/>
					</Stack>
				</FlexBox>
			</Container>
		</>
	)
}
